/**
 * Assigned Realtime Service
 *
 * Mirrors the legacy ExperienceRealtimeService API from assets/js/services.js.
 * Consumers provide a websocket client that implements `on` and `removeListener`.
 */

import RealtimeEventService from '../../../components/core/realtime/RealtimeEventService';

const EVENTS = Object.freeze({
  XPNewExperienceNotification: 'new_experience',
  XPUpdateExperienceNotification: 'experience_updated',
  XPExperienceStudentRemovedNotification: 'experience_student_removed',
});

export class AssignedRealtimeService extends RealtimeEventService {
  static EVENTS = EVENTS;

  constructor(webSocketClient, logger = console) {
    super(webSocketClient, EVENTS, 'AssignedRealtimeService', logger);
  }
}

export const assignedRealtimeEvents = EVENTS;

export default AssignedRealtimeService;
